/* eslint-disable @typescript-eslint/no-shadow */
import Loading from 'packages/common-ui/Loading';
import {createContext, useEffect, useState} from 'react';
import {auth} from 'services/firebase-service';

type FirebaseUser = firebase.default.User;

type AuthContextType = {
  /** Indicar si el usuario esta autenticado o no */
  authenticated: boolean;
  /** Objeto user que vuelve de firebase */
  user: firebase.default.User | null;
  /** Estado de cargando de la petición */
  loading: boolean;
  /** Token de autenticación */
  idToken: string | null;
  /** Verify if claims admin */
  isAdmin: boolean;
};

export const AuthContext = createContext<AuthContextType | null>({
  authenticated: null,
  loading: true,
  user: null,
  idToken: null,
  isAdmin: false,
});

const AuthProvider = ({children}: React.PropsWithChildren<{}>) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [user, setUser] = useState<firebase.default.User | null>(null);
  const [loading, setLoading] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);
  const [idToken, setIdToken] = useState('');

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user: FirebaseUser) => {
      if (user) {
        setUser(user);
        const {token, claims} = await user.getIdTokenResult();
        if (claims?.admin) setIsAdmin(true);
        setIdToken(token);
        setAuthenticated(true);
        setLoading(false);
      } else {
        setUser(null);
        setIsAdmin(false);
        setAuthenticated(false);
        setLoading(false);
      }
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <AuthContext.Provider
      value={{
        authenticated,
        user,
        loading,
        idToken,
        isAdmin,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
